<ng-container *ngIf="isCreateMode()">
  <form (ngSubmit)="save()" [formGroup]="form">
    <base-form-header [mode]="mode" createLabel="Ajouter un bâtiment"></base-form-header>

    <mat-dialog-content fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <base-form-input
          fxFlex
          label="Bâtiment"
          controlName="building"
          type="autocomplete"
          [items$]="buildings$"
          (autocompleteChange)="autocompleteBuilding($event)"
          displayProperty="labelSurface"
        ></base-form-input>

        <button
          class="ml-4 mb-5"
          color="primary"
          mat-mini-fab
          matTooltip="Créer un bâtiment"
          (click)="createBuilding()"
          type="button"
        >
          <mat-icon [icIcon]="icAdd"></mat-icon>
        </button>
      </div>

      <p
        class="text-xs text-secondary mb-4"
        [style.margin-top]="form.controls.building.invalid && form.controls.building.touched ? '4px' : '-20px'"
      >
        Sélectionner un bâtiment existant ou en créer un nouveau via le +
      </p>

      <base-form-input label="Surface utilisée (m²)" controlName="surface" type="number"></base-form-input>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <base-form-input
        type="submit"
        [mode]="mode"
        [loading]="loading"
        entityLabel="BUILDING"
        (onCreate)="createItem()"
      ></base-form-input>
    </mat-dialog-actions>
  </form>
</ng-container>
